var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"cover-block-captal","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Каптал"}},[_c('path',{staticClass:"lcp-c-3",style:({ fill: _vm.params.captalColor }),attrs:{"d":"M113.98,29.33l9.4-9.4c.39-.39,.93-.62,1.48-.62h6.68l-10.69,10.87h-6.52c-.45,0-.67-.54-.35-.85Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }